import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const NotImageIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="279"
        height="230"
        viewBox="0 0 279 230"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <g clipPath="url(#clip0_5736_19974)">
          <path
            d="M77.9004 214.592C103.32 196.995 151.792 171.177 198.169 153.34C198.991 152.605 199.827 151.863 200.676 151.116C219.678 134.318 245.048 113.361 248.104 90.4478C251.112 67.4848 231.81 42.5161 208.195 29.0303C184.58 15.5917 156.656 13.583 128.678 13.527C100.701 13.4709 72.6736 15.3351 58.7277 30.5287C44.8466 45.6781 45.0472 74.1982 42.9412 100.22C40.8351 126.242 36.3753 149.806 43.1418 171.867C48.6723 190.022 61.8425 207.224 77.9004 214.592Z"
            fill="#F2F7FF"
          />
          <path
            d="M215.625 146.975C213.162 146.132 205.104 135.471 205.104 122.82C205.104 108.122 220.652 80.3013 222.129 70.3905C223.07 64.0872 227.315 8.5542 259.549 8.5542C277.125 8.5542 278.591 42.9205 278.591 58.2911C278.591 94.1971 226.383 124.782 226.383 143.433C222.885 144.867 219.291 146.051 215.625 146.975Z"
            fill="#90C0FF"
          />
          <path
            d="M219.589 145.642C219.589 116.847 241.078 64.385 259.979 45.9232"
            stroke="#0057CB"
            strokeWidth="1.17986"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M95.5038 203.31C93.8579 202.821 89.3833 197.116 89.3833 189.766C89.3833 182.686 91.3714 172.363 91.3714 162.785C91.3714 157.458 89.3833 155.57 89.3833 149.231C89.3833 139.129 98.9578 136.052 102.315 136.052C107.255 136.052 109.898 140.279 109.898 142.518C109.898 145.642 109.013 148.013 109.013 151.47C109.013 158.228 111.373 159.074 111.125 164.897C110.388 181.919 103.32 198.561 97.1084 202.337L95.5038 203.31Z"
            fill="#0057CB"
          />
          <path
            d="M95.5039 203.31C97.5214 201.57 86.2243 146.53 76.4256 136.79C65.7656 126.204 57.0022 120.599 54.1086 117.125C48.9762 110.963 45.708 87.7255 23.1167 87.7255C17.1407 87.7255 3.05908 92.6661 0.525335 113.576C-0.303515 120.44 -1.81078 130.941 12.4743 146.158C22.0961 156.411 34.1306 152.88 45.8938 163.989C54.3622 171.985 53.1765 184.046 61.0845 194.237C67.4115 202.378 83.838 213.36 95.5039 203.31Z"
            fill="#90C0FF"
          />
          <path
            d="M92.7314 204.623C92.7314 190.81 49.1563 128.466 31.7209 119.549"
            stroke="#0057CB"
            strokeWidth="1.17986"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M95.5039 203.31C95.0703 200.036 93.2415 172.221 98.424 162.086"
            stroke="#90C0FF"
            strokeWidth="1.17986"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.0876 228.851C74.128 210.23 190.618 146.7 260.599 134.964"
            stroke="#818180"
            strokeWidth="0.884893"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M161.853 33.8591H133.557C131.602 33.8591 130.018 35.4439 130.018 37.3987V96.0907C130.018 98.0456 131.602 99.6303 133.557 99.6303H161.853C163.808 99.6303 165.393 98.0456 165.393 96.0907V37.3987C165.393 35.4439 163.808 33.8591 161.853 33.8591Z"
            fill="#0057CB"
          />
          <path
            d="M133.059 207.168V214.837H112.235V211.593L125.136 205.667L133.059 207.168Z"
            fill="#1A1A1A"
          />
          <path
            d="M178.232 199.815C179.285 202.174 181.772 208.289 181.772 208.289L171.38 214.822H161.965L160.862 211.212L172.69 202.16L178.232 199.815Z"
            fill="#1A1A1A"
          />
          <path
            d="M135.843 1.53978C134.693 -0.0412307 131.445 0.315676 128.59 2.37158C127.509 3.13396 126.591 4.10351 125.888 5.22388C125.795 5.18248 125.695 5.15945 125.593 5.15604C124.207 5.15604 101.161 17.4826 101.38 23.1695C101.598 28.8564 109.329 37.9767 112.028 39.7259C112.028 39.7259 124.207 34.039 123.552 32.2131C122.897 30.3873 115.883 24.5441 114.653 23.3878C116.098 22.6327 127.667 11.1704 128.974 9.87252C130.345 9.57912 131.638 8.99471 132.764 8.15878C135.613 6.09993 136.997 3.13849 135.843 1.53978Z"
            fill="#FFB688"
          />
          <path
            d="M118.685 92.5774C118.685 95.527 120.16 197.585 122.815 206.434C125.174 207.614 131.369 207.908 133.433 207.024C135.498 206.139 148.674 94.1938 148.674 89.2797C148.674 84.3656 118.685 92.5774 118.685 92.5774Z"
            fill="#0057CB"
          />
          <path
            d="M171.584 203.245C168.767 198.821 132.088 112.903 129.212 91.7191C132.224 89.3859 154.635 85.6664 156.449 89.9021C158.263 94.1378 180.047 198.859 179.3 200.219C178.554 201.579 173.702 203.699 171.584 203.245Z"
            fill="#90C0FF"
          />
          <path
            d="M142.362 35.6497C161.387 35.6497 160.207 88.3008 156.078 91.5454C151.948 94.79 119.649 94.9375 117.585 92.5778C115.52 90.2181 110.641 35.6497 142.362 35.6497Z"
            fill="#00355B"
          />
          <path
            d="M146.627 39.7792C146.255 41.0623 138.454 39.5049 138.604 38.0536L139.937 25.1637L149.338 27.1872C149.338 27.1872 147.005 38.502 146.627 39.7792Z"
            fill="#DB9D76"
          />
          <path
            d="M199.768 46.6927L166.777 210.242"
            stroke="#1A1A1A"
            strokeWidth="2.06475"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M194.476 91.8225C193.597 90.9337 192.463 90.3409 191.232 90.1265C187.297 83.7759 173.926 64.202 168.03 57.0905C163.779 60.1433 158.591 65.4822 158.591 65.4822C160.759 67.9127 176.997 87.1237 185.636 94.6571C185.631 95.4463 185.786 96.2284 186.09 96.9566C186.394 97.6849 186.841 98.3444 187.406 98.8958C189.592 101.084 192.949 101.273 194.901 99.3235C196.854 97.3737 196.662 94.0112 194.476 91.8225Z"
            fill="#FFB688"
          />
          <path
            d="M149.833 44.2774C157.464 38.6053 170.044 52.3211 169.838 55.9285C169.631 59.5359 159.962 67.5354 156.656 67.5442C152.618 67.5501 143.338 49.106 149.833 44.2774Z"
            fill="#00355B"
          />
          <path
            d="M142.238 32.3899C147.088 32.3899 151.019 27.4324 151.019 21.317C151.019 15.2016 147.088 10.244 142.238 10.244C137.388 10.244 133.457 15.2016 133.457 21.317C133.457 27.4324 137.388 32.3899 142.238 32.3899Z"
            fill="#FFB688"
          />
          <path
            d="M129.224 49.7043C131.879 47.5687 127.484 29.6614 122.774 29.2219C118.063 28.7824 109.848 37.6579 110.179 40.1769C110.509 42.6959 122.517 55.0726 129.224 49.7043Z"
            fill="#00355B"
          />
          <path
            d="M156.204 17.5562C156.204 15.3115 154.06 13.6922 154.06 12.4474C154.06 11.2027 154.795 8.97272 153.152 7.37696C151.155 5.43905 147.972 6.24725 145.123 6.24725C142.444 6.24725 140.967 3.13538 137.312 3.13538C134.876 3.13538 135.185 6.29739 134.274 7.082C133.598 7.67193 128.333 8.80459 128.333 11.2115C128.333 13.9016 128.404 17.5119 133.991 17.5119C134.362 16.22 135.76 13.3824 137.353 12.12C138.173 12.474 142.663 14.3263 143.775 14.6537C144.887 14.9811 146.512 19.7419 148.235 20.3171C149.957 20.8922 150.066 24.0631 151.326 23.9274C152.585 23.7917 156.204 23.2608 156.204 17.5562Z"
            fill="#1A1A1A"
          />
          <path
            d="M149.798 24.512C151.08 24.512 152.119 23.4727 152.119 22.1906C152.119 20.9086 151.08 19.8693 149.798 19.8693C148.516 19.8693 147.477 20.9086 147.477 22.1906C147.477 23.4727 148.516 24.512 149.798 24.512Z"
            fill="#FFB688"
          />
        </g>
        <defs>
          <clipPath id="clip0_5736_19974">
            <rect
              width="278.561"
              height="228.757"
              fill="white"
              transform="translate(0.0297852 0.54834)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
);
export default NotImageIcon;
